import { View } from 'react-native'
import { Input } from '@/src/common/components/Input'
import { DropdownComponent } from '@/src/common/components/Dropdown'
import {
  type Address,
  type AddressInputsProps,
  stateDropdownItems,
} from '@/src/common/components/AutoCompleteAddress/AutoCompleteAddressCommon'
import { mesaColorNames } from '@/src/common/theme'
import Ionicons from '@expo/vector-icons/Ionicons'

const ZipCodeAddressInputs = (props: AddressInputsProps) => {
  const handleAddressChange = <T extends keyof Address>(field: T, value: Address[T]) => {
    // HACK: We have no way to detect if the "clear" button is pressed on the text input,
    // so let's just clear out the entire structure if street1 is erased
    if (field === 'zipCode' && value === '') {
      props.onChange(undefined)
      return
    }

    props.onChange({
      ...props.address,
      [field]: value,
    })
  }

  const validationErrorsToShow = props.showValidationErrors ? props.validationErrors : undefined

  return (
    <View style={{ gap: 10 }}>
      <Input
        placeholder="Zip Code"
        value={props.address.zipCode}
        onChangeText={(value) => handleAddressChange('zipCode', value)}
        leftIcon={
          <Ionicons
            size={24}
            name="location-outline"
            color={mesaColorNames['semantic/fg/subtle #898D8F']}
          />
        }
        clearButtonMode="always"
        segmentAction="User Inputs Zip Code"
        style={styles.inputContainer}
        info={{ error: validationErrorsToShow?.zipCode }}
        testID={props.testIDPrefix ? `${props.testIDPrefix}#ZipCode` : undefined}
      />
      <View style={{ flexDirection: 'row', gap: 10 }}>
        <View style={{ flex: 1 }}>
          <Input
            placeholder="City"
            value={props.address.city}
            onChangeText={(value) => handleAddressChange('city', value)}
            segmentAction="User Inputs City"
            containerStyle={styles.inputContainer}
            info={{ error: validationErrorsToShow?.city }}
            testID={props.testIDPrefix ? `${props.testIDPrefix}#City` : undefined}
          />
        </View>
        <View style={{ flex: 1 }}>
          <DropdownComponent
            value={props.address.state}
            data={stateDropdownItems}
            labelField="label"
            valueField="value"
            onChange={(selectedItem) => handleAddressChange('state', selectedItem.value)}
            segmentAction="User Inputs State"
            containerStyle={styles.inputContainer}
            testID={props.testIDPrefix ? `${props.testIDPrefix}#State` : undefined}
          />
        </View>
      </View>
    </View>
  )
}

const styles = {
  inputContainer: {
    paddingHorizontal: 0,
  },
}

export default ZipCodeAddressInputs
